import { createContext, useContext, useMemo } from 'react';
import type { ReactNode } from 'react';
import { UNSAFE_LocationContext, useLocation, useNavigationType } from 'react-router-dom';
import type { Location } from 'react-router-dom';

const PageActiveContext = createContext(true);
export const usePageActive = () => useContext(PageActiveContext);

// Each open tab keeps its own component tree, scroll container and location.
// Removing a tab unmounts that tree and releases its state.
export default function CachedPage({ savedLocation, children }: { savedLocation: Location; children: ReactNode }) {
  const current = useLocation();
  const navigationType = useNavigationType();
  const active = current.pathname === savedLocation.pathname;
  const location = active ? current : savedLocation;
  const context = useMemo(() => ({ location, navigationType }), [location, navigationType]);
  return <div className="workspace-page" style={{ display: active ? 'block' : 'none' }} aria-hidden={!active}>
    <PageActiveContext.Provider value={active}>
      <UNSAFE_LocationContext.Provider value={context}>{children}</UNSAFE_LocationContext.Provider>
    </PageActiveContext.Provider>
  </div>;
}
